import { render, staticRenderFns } from "./CollectionAddForm.vue?vue&type=template&id=cb198eca"
import script from "./CollectionAddForm.vue?vue&type=script&lang=js"
export * from "./CollectionAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports